// src/components/character/characterQrPayload.js

/**
 * Build the build-data payload for a character's printed sheet QR code.
 *
 * This is stored server-side (via POST /qrCode) and resolved back by
 * qrCodeId at checkout scan time (via GET /qrCode/{qrCodeId}) — the QR code
 * itself only encodes that id, not this payload.
 *
 * Encodes IDs for anything that has a catalog ID (races, skillsets,
 * transforms, skills, knowledges), and whole values for everything else
 * (name, subRace, point totals). Skill/knowledge names, descriptions, and
 * costs are intentionally left out — the scan-ingestion endpoint resolves
 * those from the current catalogs on demand.
 */
export function buildCharacterQrPayload(character) {
    if (!character) return null;

    const skills = Array.isArray(character.skills)
        ? character.skills.map((s) => [s.skillId, s.ranks])
        : [];
    const knowledges = Array.isArray(character.knowledges)
        ? character.knowledges.map((k) => [k.knowledgeId, k.ranks])
        : [];

    return {
        characterId: character.characterId,
        name: character.name,
        subRace: character.subRace,
        raceId: character.raceId,
        skillsetPrimary: character.skillsetPrimary,
        skillsetSecondary: character.skillsetSecondary,
        transformId: character.transformId,
        skillPointsTotal: character.skillPointsTotal,
        skillPointsDebt: character.skillPointsDebt,
        skillPointsEffective: character.skillPointsEffective,
        bankBalance: character.bankBalance,
        skills,
        knowledges,
    };
}
